export enum ProgramStatus {
  /** Published and attached to an active enrollment period: accepting live data, structure locked. */
  active = 'Active',
  archived = 'Archived',
  draft = 'Draft',
  pendingChanges = 'PendingChanges',
  published = 'Published'
}
